<template>
  <div :class="ie ? 'feed ie' : 'feed'">
    <h1>Что говорят наши студенты</h1>
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(feed, i) in feedsList" :key="i">
          <!-- <div class="feed_info">
                  <img src="@/assets/img/feed_1.png" />
                  <div class="text">
                     <p>Гришина Снежана</p>
                     <span>10 дней назад</span>
                     <div class="stars_block">
                        <i class="mdi mdi-star active"></i>
                        <i class="mdi mdi-star active"></i>
                        <i class="mdi mdi-star active"></i>
                        <i class="mdi mdi-star active"></i>
                        <i class="mdi mdi-star"></i>
                     </div>
                  </div>
               </div> -->
          <div class="feed_body">{{ feed }}</div>
        </div>
      </div>
    </div>
    <div class="controls" v-if="!ie" :style="{ display: isButtonShow() ? 'flex' : 'none' }">
      <div class="swiper-button swiper-button-prev"><i class="icon-button-arrow"></i></div>
      <div class="swiper-pagination"></div>
      <div class="swiper-button swiper-button-next"><i class="icon-button-arrow"></i></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Feed',
  props: {
    ie: {
      default: () => false,
      type: Boolean
    },
    feedsList: {
      default: () => [],
      type: Array
    }
  },
  data() {
    return {
      deviceWidth: 1920
    }
  },
  mounted() {
    this.deviceWidth = window.innerWidth
    window.onresize = () => {
      this.deviceWidth = window.innerWidth
    }
  },
  beforeDestroy() {
    window.onresize = null
  },
  methods: {
    isButtonShow() {
      if (this.deviceWidth < 500 && this.feedsList.length === 1) {
        return false
      } else if (this.deviceWidth >= 500 && this.deviceWidth < 900 && this.feedsList.length <= 2) {
        return false
      } else if (this.deviceWidth >= 900 && this.feedsList.length <= 3) {
        return false
      }
      return true
    }
  }
}
</script>
